const PRODUCTION_API_HOST = "api-production.tugruero.io";
const DEFAULT_TITLE = "Módulo de Operaciones";

export function getApiHost() {
  const raw = process.env.REACT_APP_API_URL;

  if (!raw) {
    return "";
  }

  try {
    return new URL(raw).host;
  } catch {
    return raw.replace(/^https?:\/\//, "").split("/")[0];
  }
}

export function isProductionApi() {
  return getApiHost().toLowerCase() === PRODUCTION_API_HOST;
}

function getFrontendKind() {
  if (typeof window === "undefined") {
    return "hosted";
  }

  const host = window.location.hostname;

  if (host === "localhost" || host === "127.0.0.1") {
    return "local";
  }

  if (host.endsWith(".amplifyapp.com")) {
    return "preview";
  }

  return "hosted";
}

export function getEnvBanner() {
  const apiHost = getApiHost() || "API no configurada";
  const frontend = getFrontendKind();
  const branch = (process.env.REACT_APP_BRANCH || "").trim();
  const prodApi = isProductionApi();

  if (prodApi && frontend === "hosted") {
    return null;
  }

  if (prodApi) {
    return {
      tone: "danger",
      title: "PRODUCCIÓN",
      text: `Este frontend (${frontend}) apunta a ${apiHost}`,
    };
  }

  return {
    tone: "warning",
    title: branch || "NO-PROD",
    text: `API: ${apiHost}`,
  };
}

export function applyEnvDocumentMeta(banner) {
  if (!banner) {
    document.title = DEFAULT_TITLE;
    document.body.removeAttribute("data-env-tone");
    return;
  }

  document.title = `[${banner.title}] ${DEFAULT_TITLE}`;
  document.body.dataset.envTone = banner.tone;
}

export function clearEnvDocumentMeta() {
  document.title = DEFAULT_TITLE;
  document.body.removeAttribute("data-env-tone");
}
